import {
  SHOW_DROP_DOWN_VALUE_FAIL,
  SHOW_DROP_DOWN_VALUE_REQUEST,
  SHOW_DROP_DOWN_VALUE_SUCCESS,
} from "../../ActionType/Section&FieldsTypes/SectionFielsTypes";

export const showDropDwonValuesReducer = (
  state = { loading: true, items: [], error: "" },
  action
) => {
  switch (action.type) {
    case SHOW_DROP_DOWN_VALUE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SHOW_DROP_DOWN_VALUE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload,
        error: "",
      };
    case SHOW_DROP_DOWN_VALUE_FAIL:
      return {
        ...state,
        loading: false,
        items: [],
        error: "",
      };
    default:
      return state;
  }
};
